import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DocumentPreviewDialog = ({ open, fileUrl, handleClose }) => {
  const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
        <DialogTitle sx={{ fontWeight: "bold", color: "#028391" }}>Document Preview</DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
        {isPDF ? (
          <iframe src={fileUrl} width="100%" height="500px" title="PDF Preview" style={{ border: "none" }} />
        ) : (
          <img src={fileUrl} alt="Document Preview" style={{ maxWidth: "100%", maxHeight: "500px", objectFit: "contain" }} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DocumentPreviewDialog;
